/**
 * Created by linjianxi on 2016/10/29.
 */
import * as types from './mutation-type'
import * as http from '../../../utils/common'
import {session} from '../../../utils/storage'
import cookie from '../../../utils/cookie'
import {GetEnableCashCouponAmount} from '../../../utils/environconfig'
/**
 * 获取浪客直播账户详情
 * @param commit
 * @param params
 */
export const getLiveAccounts = ({commit}, params) => {
  http.post({
    url: '/api/FundSearch/GetLiveAccounts',
    data: {},
    succ: function (res) {
      console.log(res)
      if (res.result === 1) {
        session.setItem('CustomerName', res.data.certificate_name)
        session.setItem('CertificateNo', res.data.certificate_no)
        commit(types.GET_HQPORD_LIVE_COUNT, res.data)
        setTimeout(function () {
          if (params._this.updateSystem().bankState === 1) {
            params._this.ScrollImgLeft()
          }
        }, 500)
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}
/**
 * 获取我的活期宝账号详情
 * @param commit
 * @param params
 */
export const getHqpordIndex = ({commit}, params) => {
  http.post({
    url: '/api/FundHqb/GetHqbAccounts',
    data: params,
    succ: function (res) {
      console.log(res)
      if (res.result === 1) {
        commit(types.GET_HQPORD_INDEX_LIST, res.data)
      } else {
        alert(res.message)
      }
    }
  })
}
/**
 * 显示活期宝余额
 * @param commit
 * @param params
 */
export const changeLook = ({commit}, params) => {
  commit(types.CHECK_OPEN_MONEY_STATUS, params)
}

/**
 * 获取用户红包
 * @param commit
 * @param params
 */
export const getRedInfor = ({commit}, params) => {
  console.log(params)
  $.ajax({
   // url: 'http://livemoneyapitest.eastmoney.com/api/myaccount/GetEnableCashCouponAmount',
    url: GetEnableCashCouponAmount,
    data: 'device_id=' + cookie('device_id') + '&ctoken=' + cookie('ctoken') + '&utoken=' + cookie('utoken'),
    type: 'get',
    timeout: 15000,
    dataType: 'jsonp',
    jsonp: 'callback',
    success: function (res) {
      console.log(res)
      if (res.result === 1) {
        let redCount = 0
        for (let v in res.data) {
          redCount += res.data[v]
        }
        console.log(redCount)
        params._this.redCount = redCount
      }
    }
  })
}




// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_index/actions.js